import { render } from "./DesignAboutMe.vue?vue&type=template&id=947bb906&scoped=true"
import script from "./DesignAboutMe.vue?vue&type=script&lang=js"
export * from "./DesignAboutMe.vue?vue&type=script&lang=js"

import "./DesignAboutMe.vue?vue&type=style&index=0&id=947bb906&scoped=true&lang=css"
import "./DesignAboutMe.vue?vue&type=style&index=1&id=947bb906&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947bb906"]])

export default __exports__